import { useTranslation } from 'react-i18next';
import WarningIcon from 'assets/images/icons/warning.svg?react';
import OverallRating from 'pages/property/reviews/components/overallRating/OverallRating';
import {
  AverageRatingReviewsContainer,
  RecentTripIssuesContainer,
} from './OverallAirbnbRatings.styles';

const AverageRatingReviews = ({
  reviewsAmount,
  averageRating,
  reviewUidsWithIssues,
}: {
  reviewsAmount: number;
  averageRating: number;
  reviewUidsWithIssues: string[];
}) => {
  const { t } = useTranslation();

  const hasRecentTripIssues = reviewUidsWithIssues?.length > 0;

  return (
    <AverageRatingReviewsContainer data-testid="average-rating-reviews">
      <OverallRating
        title={t('pageProperty.reviews.airbnbGuest.overallAirbnbRating.title')}
        averageRating={averageRating}
        reviewsAmount={reviewsAmount}
      />

      {hasRecentTripIssues && (
        <RecentTripIssuesContainer data-testid="recent-trip-issues-container">
          <WarningIcon />
          {t(
            'pageProperty.reviews.airbnbGuest.overallAirbnbRating.recentTripIssues',
          )}
        </RecentTripIssuesContainer>
      )}
    </AverageRatingReviewsContainer>
  );
};

export default AverageRatingReviews;
